<template>
    <div v-if="data">



        <success :rowid="$route.params.rowid" :cont="$route.params.cont" :cust="$route.params.cust" :roleID="this.role" v-if="showSuccess" />
        <div v-if="canceledLink == 1 && statusApprove == 0">
            <!--<div class="text-center" v-if="LoadingSpiner">
          <div class="loader-container">
            <div class="item-1"></div>
            <div class="item-2"></div>
            <div class="item-3"></div>
            <div class="item-4"></div>
            <div class="item-5"></div>
          </div>
        </div>-->
            <div class="loader">
                <div class="square-spin">
                    <div><img src="../assets/img/A-White.svg"></div>
                </div>
            </div>
            <!--<monitoring class="monitoring" @updateParent="updateMonitoring" :data="data" v-if="monitoring>0"/>-->
            <div class="main-container" v-if="!showSuccess">
                <header class="d-md-flex d-sm-block header-background-e ">
                    <div class="col-md-3 col-sm-12 header-background-color header-background text-center pt-sm-5 pb-sm-5">
                        <!--<img src="../assets/img/logo-wh.svg" width="170" class=" d-sm-block d-md-none sm-img ">-->
                        <template v-if="$t('isgeo') == 1">
                            <img src="../assets/img/logo-wh.svg" width="170" class="d-md-none sm-img">
                        </template>
                        <template v-else>
                            <img src="../assets/img/logoEn.png" height="80" class="mt-3 d-md-none sm-img">
                        </template>
                    </div>
                    <div class="col-md-9 col-sm-12 d-lg-flex d-md-flex d-sm-block p-4">
                        <template v-if="isGeo === 1">
                            <img src="../assets/img/ardi-logo.svg" width="170" class="d-md-block d-sm-none extra">
                        </template>
                        <template v-else>
                            <img src="../assets/img/logoEn1.svg" width="170" class="d-md-block d-sm-none extra">
                        </template>
                        <h1 class="ml-md-5 nino-mtavruli text-md-left text-center font-weight-bold mt-3">{{$t('pcbslogan')}}</h1>
                    </div>
                </header>
                <main>
                    <b-container>
                        <b-col cols="10" offset="1" class="pt-3">
                            <b-row>
                                <!--Policy-->
                                <b-col md="3" sm="12" class="text-center policy-number-background p-2 rounded-left">
                                    {{ data.policyInfo[0].TARIFFGROUP }}
                                </b-col>
                                <b-col md="9" sm="12"
                                       class="text-center header-background-e p-2 rounded-right font-weight-bold nino-mtavruli">
                                    {{ data.policyInfo[0].POLICYPRODUCT }}
                                </b-col>
                                <!--Insurer-->
                                <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                                    <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli"> {{$t('Insurer')}}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('companyname')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2 ">
                                    <div class="text-center">
                                        <div>{{$t('JSCardi')}}</div>
                                    </div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('taxnumber')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2 ">
                                    <div class="text-center">

                                        <div> {{ data.policyInfo[0].COMPSOCCART }}</div>
                                    </div>
                                </b-col>


                                <!--Owner-->
                                <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                                    <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{$t('policyholder')}}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">
                                    {{$t('namesurname')}}
                                </b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].CUSTOMERNAME }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('pnumber')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].CUSTOMERSOCCARD }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('mob')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].CUSTOMERPHONENUMBER }}</div>
                                </b-col>


                                <template v-for="(item,index) in data.clients">
                                    <template v-if="item.Status ==='მოსარგებლე'">
                                        <b-col cols="12" class="description mt-3 p-2">
                                            და აგრეთვე ყველა ის ფიზიკური და/ან იურიდიული პირი და/ან პირთა გაერთიანება, რომლებმაც გააფორმეს გენერალური და/ან საკრედიტო
                                            ხელშეკრულება სს პროკრედიტ ბანკთან წინამდებარე პოლისში მითითებული დაზღვევის ობიექტის უზრუნველყოფით
                                        </b-col>
                                        <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                                            <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{$t('beneficiarypcbuser')}}</div>
                                        </b-col>
                                    </template>
                                    <template v-if="item.Status ==='მსესხებელი'">
                                        <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                                            <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{$t('beneficiarypcbborrower')}}</div>
                                        </b-col>

                                    </template>
                                    <template v-if="item.Status ==='ბენეფიციარი'">
                                        <b-col md="12" sm="12" class="mt-3 p-2 content-header ">
                                            <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{$t('beneficiarypcb')}}</div>
                                        </b-col>
                                    </template>
                                    <b-col md="3" sm="12" class="description p-2 value-border-top">
                                        {{$t('namesurname')}}
                                    </b-col>
                                    <b-col md="9" sm="12" class="value-background p-2  ">
                                        <div class="text-center">{{ item.Name }}</div>
                                    </b-col>
                                    <template v-if="item.Status ==='მსესხებელი'">
                                        <b-col md="3" sm="12" class="description p-2 value-border-top">
                                            {{$t('address')}}
                                        </b-col>
                                        <b-col md="9" sm="12" class="value-background p-2  ">
                                            <div class="text-center">{{ item.Saddress }}</div>
                                        </b-col>
                                    </template>
                                    <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('pnumber')}}</b-col>
                                    <b-col md="9" sm="12" class="value-background p-2  ">
                                        <div class="text-center">{{ item.Soccart }}</div>
                                    </b-col>
                                    <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('mob')}}</b-col>
                                    <b-col md="9" sm="12" class="value-background p-2  ">
                                        <div class="text-center">{{ item.Phone }}</div>
                                    </b-col>
                                </template>




                                <b-col md="3" sm="12" class="mt-3 p-2 extra content-header ">
                                </b-col>
                                <b-col md="9" sm="12" class="mt-3 p-2 content-header ">
                                    <div class="text-center nino-mtavruli">{{$t('vehicleinformation')}}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('automodelPcb')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].CARMARKVALUE }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('vincode')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].VINCODE }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('year')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center">{{ data.policyInfo[0].PRODUCTIONDATE }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('carregnumber')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center"> {{ data.policyInfo[0].PLATENUMBER1 }}</div>
                                </b-col>
                                <b-col md="3" sm="12" class="description p-2 value-border-top">{{$t('suminsurePrc')}}</b-col>
                                <b-col md="9" sm="12" class="value-background p-2  ">
                                    <div class="text-center"> {{ data.casco[0].amount }}</div>
                                </b-col>





                                <template v-for="(risk,index) in data.tpl_ma_Risks">
                                    <b-col md="12" sm="12" class="mt-3 p-2 content-header " :key="index">
                                        <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">
                                            {{ risk.risk }}
                                        </div>
                                    </b-col>
                                    <b-col md="3" sm="12" class="description p-2 value-border-top" style="font-weight: bold;" :key="index">{{$t('suminsured')}}</b-col>
                                    <b-col md="9" sm="12" class="value-background p-2  " :key="index">
                                        <div class="text-center">{{ risk.amount }}</div>
                                    </b-col>
                                    <template v-if="risk.limit">
                                        <b-col md="3" sm="12" class="description p-2 value-border-top risk-header-1" style="font-weight: bold;" :key="index">
                                            {{$t('sublimitper')}}
                                        </b-col>
                                        <b-col md="9" sm="12" class="value-background p-2  " :key="index">
                                            <div class="text-center">{{ risk.limit }}</div>
                                        </b-col>
                                    </template>
                                </template>
                                <div class=" col-12 mt-3 p-0 ">
                                    <table class=" " id="insured-risk">
                                        <thead class="description-box">
                                            <tr>
                                                <th rowspan="2" width="74%">
                                                    <div class="pl-1 risk-header-1 nino-mtavruli">{{$t('insuredrisk')}}</div>
                                                </th>
                                                <th colspan="2" width="20%" class="text-center risk-header-2 nino-mtavruli">{{$t('deductible')}}</th>
                                            </tr>
                                            <tr>
                                                <th width="13%" class="text-center risk-header-2 nino-mtavruli">{{$t('loss')}}</th>
                                                <th width="13%" class="text-center risk-header-2 nino-mtavruli">{{$t('totalloss')}}</th>
                                                <!--<th width="13%" class="text-center risk-header-2 nino-mtavruli">{{$t('totalloss')}}</th>-->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(risk, index) in data.insuredRisks">
                                                <!--risk-->
                                                <tr :key="index" v-show="risk.riskstate==='დაზღვეული' || risk.riskstate==='Insured'">
                                                    <td class="p-0">
                                                        <div class="d-flex p-0">
                                                            <div v-if="risk.img" class=" pb-1 pr-1">
                                                                <img :src='"../assets/img/"+risk.img+"-sq.svg"' width="20">
                                                            </div>
                                                            <div :key="index" :class="{sub_risk_text_color: risk.img, 'p-1' :!risk.img}"
                                                                 class="pl-1 pr-1 ">
                                                                {{ risk.risk }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <template v-if="risk.fR_Total === null || risk.fR_Total == '' || risk.fR_Total == '0 %'">
                                                        <td :key="index" class="text-center">{{risk.cnorate }}</td>
                                                        <td :key="index" class="text-center">{{  risk.fR_Total == '0 %' ? risk.fR_Total : '-'}}</td>
                                                    </template>

                                                    <template v-else>
                                                        <td :key="index" class="text-center"> {{risk.fR_Type}}  {{risk.fR_Total}} მინ.{{risk.cnorate }}</td>
                                                        <td :key="index" class="text-center">{{ risk.fR_Total }}</td>
                                                       
                                                    </template>
                                                   
                                                    <!--<td :key="index" class="text-center">{{ risk.cnoback }}</td>-->
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>

                                <div class=" col-12 mt-3 p-0">
                                    <table class="" id="extra-risk">
                                        <thead class="description-box">
                                            <tr>

                                                <th width="80%" class="border-bottom-0 border-left-0 border-top-0">
                                                    <div class="pl-1 nino-mtavruli" style="font-weight: bold;">{{$t('additionalrisksPcb')}}</div>
                                                </th>
                                                <th width="10%" class="text-center border-bottom-0 border-top-0 nino-mtavruli">{{$t('limit')}}</th>
                                                <th width="10%" class="text-center border-bottom-0 border-right-0 border-top-0 nino-mtavruli">{{$t('deductible')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(risk, index) in data.innovativeRisks">
                                                <!--risk-->
                                                <tr :key="index" v-show="risk.riskstate==='დაზღვეული' || risk.riskstate==='Insured'">
                                                    <td class="p-0">
                                                        <div class="d-flex p-0">
                                                            <div v-if="risk.img" class="pb-1 pr-1">
                                                                <img :src='"../assets/img/"+risk.img+"-sq.svg"' width="20">
                                                            </div>
                                                            <div :key="index" class="pl-1 pr-1">
                                                                {{ risk.risk }}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td :key="index" class="text-center" :colspan="risk.box">{{risk.risk =='საევაკუაციო მომსახურება სადაზღვევო შემთხვევისას' ? 'ულიმიტო': risk.amount }}</td>
                                                    <td :key="index" class="text-center" v-if="risk.box===1">{{ risk.cnoback }}</td>
                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </div>

                                <b-col cols="12" class="rounded-top description mt-3 p-2 nino-mtavruli " style="font-weight: bold;"
                                       v-if="data.policyInfo[0].ADDNOTE">
                                    {{$t('additionalinformation')}}
                                </b-col>
                                <b-col cols="12" class="value-background p-2" v-if="data.policyInfo[0].ADDNOTE">
                                    {{ data.policyInfo[0].ADDNOTE }}
                                </b-col>

                                <b-col cols="12" class="description mt-3 p-2 nino-mtavruli" style="font-weight: bold;"
                                       v-if="data.policyInfo[0].DRIVERRULES ||data.policyInfo[0].OWNNAME">
                                    {{$t('authorizeddriver')}}
                                </b-col>
                                <b-col cols="12" class="value-background p-2" v-if="data.policyInfo[0].DRIVERRULES">
                                    {{ data.policyInfo[0].DRIVERRULES }}
                                </b-col>
                                <!--<b-col cols="12" class="value-background p-2" v-if="data.policyInfo[0].OWNNAME">
                                {{ data.policyInfo[0].OWNNAME }}
                            </b-col>-->

                                <b-col cols="12" class="description mt-3 p-2 nino-mtavruli" style="font-weight: bold;">{{$t('insurancearea')}}</b-col>
                                <b-col cols="12" class="value-background p-2">{{ data.policyInfo[0].COUNTRYS }}</b-col>

                                <b-col cols="6" class="description mt-3 p-2 nino-mtavruli" style="font-weight: bold;">{{$t('yearpremium')}}</b-col>
                                <b-col cols="6" class="description mt-3 p-2 left-border nino-mtavruli" style="font-weight: bold;">{{$t('paymentcount')}}</b-col>
                                <b-col cols="6" class="value-background p-2"> {{ data.policyInfo[0].INSURANCEPREMIUMS }}</b-col>
                                <b-col cols="6" class="value-background p-2"> {{ data.policyInfo[0].PAYMENTCOUNT }}</b-col>


                                <b-col cols="12" class="mt-3 p-2 value-background rounded-top sub-risk-text-color nino-mtavruli" style="font-weight: bold;">
                                    {{$t('paymentschedule')}}
                                </b-col>

                                <template v-if="data.payment.length>=2">
                                    <div class="col-3  p-2 value-background">
                                        {{$t('date')}}
                                    </div>
                                    <div class="col-3  p-2 value-background">
                                        {{$t('amount')}}
                                    </div>
                                    <div class="col-3  p-2 value-background">
                                        {{$t('date')}}
                                    </div>
                                    <div class="col-3  p-2 value-background">
                                        {{$t('amount')}}
                                    </div>

                                    <div class="col-12 border-0"></div>

                                    <template v-for="(payment,index) in data.payment">
                                        <!--//.slice(0, data.payment.length/2)">-->

                                        <div :key="index" class="col-3 p-2 value-background">
                                            {{ payment.PAYDATE }}
                                        </div>
                                        <div :key="index" class="col-3 p-2 value-background">
                                            {{ payment.PAYAMAUNT }}
                                        </div>
                                    </template>
                                </template>

                                <template v-if="data.payment.length<2">
                                    <div class="col-6  p-2 value-background">
                                        {{$t('date')}}
                                    </div>
                                    <div class="col-6  p-2 value-background">
                                        {{$t('amount')}}
                                    </div>


                                    <div class="col-12 border-0"></div>

                                    <template v-for="(payment,index) in data.payment">
                                        <!--//.slice(0, data.payment.length/2)">-->

                                        <td :key="index" class="col-6 p-2 value-background">
                                            {{ payment.PAYDATE }}
                                        </td>
                                        <td :key="index" class="col-6 p-2 value-background">
                                            {{ payment.PAYAMAUNT }}
                                        </td>
                                    </template>
                                </template>

                                <div class="col-12 "></div>

                                <td class="col-12 description-box mt-1 nino-mtavruli" style="font-weight: bold;">
                                    {{$t('coverfrom')}}
                                </td>

                                <td class="col-12 border-0 mt-1">
                                    <div class="row ">

                                        <div class="col-md-2 col-6 payment-title border-0">
                                            {{$t('from')}}
                                        </div>
                                        <div class="col-md-4 col-6 ">
                                            {{ data.policyInfo[0].FROMDATE }}
                                        </div>
                                        <div class="col-md-2 col-6 payment-title border-0">
                                            {{$t('including')}}
                                        </div>
                                        <div class="col-md-4 col-6">
                                            {{ data.policyInfo[0].TODATE }}
                                        </div>

                                    </div>
                                </td>

                                <!--<b-col cols="12" class="rounded p-2 value-background mt-3">-->
                                <!--{{ data.policyInfo[0].NOTS }}-->
                                <!--{{$t('mhlnots')}}
                                <a :href="data.policyInfo[0].LINKNOTS" target="_blank"
                                   class="conditions">{{ data.policyInfo[0].LINKNOTS }}</a>
                            </b-col>-->



                                <b-col md="12" sm="12" class="p-2 content-header mt-2 ">
                                    <div class="col-md-12 col-sm-12 text-center nino-mtavruli">პოლისის გაცემის საფუძვლები</div>
                                </b-col>
                                <b-col md="5" sm="12" class="description p-2 ">ავტომობილის საკრედიტო დაზღვევის პირობები ვერსია 1.20</b-col>
                                <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                                    <div class="text-center">
                                        <div style="cursor: pointer; color: -webkit-link; " >
                                            <a v-bind:href='data.policyInfo[0].Condition' target="_blank">{{data.policyInfo[0].Condition}}</a>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="5" sm="12" class="description p-2 ">გენერალური ხელშეკრულება</b-col>
                                <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                                    <div class="text-center">
                                        <div>{{data.policyInfo[0].CONTNUM}}</div>
                                    </div>
                                </b-col>

                                <b-col md="12" sm="12" class="border-green p-2 mt-2">
                                    <div class="">
                                        მე დამზღვევი/დაზღვეული, ვაცნობიერებ, რომ პოლისი შეიცავს ჩემს მიერ მოწოდებულ მონაცემებს და ვადასტურებ, რომ ისინი სრულყოფილი
                                        და სწორია. აგრეთვე, ვაცხადებ, რომ დეტალურად განმემარტა სს "არდი დაზღვევა"-ს ავტომობილის საკრედიტო დაზღვევის პირობები, ვეთანხმები და
                                        ვკისრულობ მასში გათვალისწინებული ვალდებულებების სრულად შესრულების ვალდებულებას. ამასთან, თანახმა ვარ, რომ მრავალწლიანი
                                        სესხის შემთხვევაში, პოლისი განახლდეს ავტომატურად, გარდა იმ შემთხვევისა, თუ არ იცვლება(იზრდება) პოლისით გათვალისწინებული
                                        სადაზღვევო გადასახადი (სადაზღვევო პრემია). დაზღვეული/მსესხებელი უფლებამოსილებას ანიჭებს ბანკს, მისი ნებისმიერი ანგარიშიდან,
                                        მისი თანხმობის გარეშე, ჩამოწეროს სადაზღვევო პრემიის თანხა და განახორციელოს ანგარიშსწორება სადაზღვევო კომპანიასთან.
                                        სადაზღვევო კომპანიასთან ანგარისსწორება ხდება ეროვნულ ვალუტაში (ლარში), თუ მსესხებლის ანგარიშზე არსებული თანხა სხვა ვალუტაშია,
                                        ბანკი უფლებამოსილია მსესხებლის ხარჯზე მოახდინოს სავალუტო ერთეულიდან მეორეში თანხის კონვერტაცია, ანგარიშიდან თანხის
                                        ჩამოწერის დღისთვის ბანკში მოქმედი კომერციული კურსის შესაბამისად, ასევე ჩამოწეროს კონვერტაციის საკომისიო (არსებობის
                                        შემთხვევაში).
                                    </div>
                                </b-col>

                                <b-col md="12" sm="12" class="mt-2 p-2 content-header1">
                                    <div class="col-md-9 col-sm-12 nino-mtavruli pl-2 d-flex">
                                        <b-form-checkbox v-model="checked" :disabled="role == 0" class="d-md-flex justify-content-md-around" size="lg"></b-form-checkbox>
                                        <div class="mt-1" style="font-size: 14px;">
                                            გავეცანი სს "არდი დაზღვევა"-ს ავტომობილის საკრედიტო დაზღვევის პირობებს ბმულზე :
                                            <a v-bind:href='data.policyInfo[0].Condition' target="_blank">{{data.policyInfo[0].Condition}}</a>

                                        </div>
                                    </div>
                                </b-col>

                                <div class="mt-3 col-md-12 col-sm-12 d-flex p-0  ">
                                    <b-button variant="success" class="mr-3 accept-text approve-cancel-btn" :disabled="!checked" @click="submit">პოლისის შექმნა</b-button>
                                    <b-button @click="Denial" class="accept-text approve-cancel-btn" style="background-color: darkgray;">პოლისის უარყოფა</b-button>

                                </div>

                                <template v-if="role == 0 || role == 2">
                                    <b-col md="12" sm="12" class="p-2 content-header mt-4 mt-sm">
                                        <div class="col-md-12 col-sm-12 text-center nino-mtavruli">ხელმოწერები</div>
                                    </b-col>
                                    <signature :roleid="this.role" class="col-12" />
                                </template>


                                <b-modal v-model="denial" size="sm" :ok-title="$t('finish')" ok-only @ok="reject"
                                         :title="$t('reasonrejection')">
                                    <b-form-checkbox id="checkbox-2"
                                                     v-model="rejectStatus"
                                                     class="mt-3"
                                                     value="56">
                                        {{$t('defectdata')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox id="checkbox-3"
                                                     v-model="rejectStatus"
                                                     class="mt-3"
                                                     value="54">
                                        {{$t('denialcondition')}}
                                    </b-form-checkbox>
                                </b-modal>
                                <!--<b-modal v-model="status" size="lg" :ok-title="$t('policydecoration')" ok-only @ok="submit">
                                    <conditions :policy="data.policyInfo[0].POLICYPRODUCT"
                                                :start="data.policyInfo[0].FROMDATE"
                                                :end="data.policyInfo[0].TODATE"
                                                :isgeo="isGeo" />
                                </b-modal>-->

                                <b-modal v-model="status1" size="lg" :ok-title="$t('finish')" ok-only @ok="finish">
                                    {{$t('notactive')}}
                                    {{ this.data.policyInfo[0].NMG_NAME_A }} {{ this.data.policyInfo[0].MNG_LASTNAME }},
                                    <a :href='"tel:+995"+this.data.policyInfo[0].MNG_PHONE'>{{ this.data.policyInfo[0].MNG_PHONE }}</a>,
                                    <a :href='"mailto:"+this.data.policyInfo[0].MNG_EMAIL'>{{ this.data.policyInfo[0].MNG_EMAIL }}</a>
                                </b-modal>


                            </b-row>
                        </b-col>

                        <b-col cols="10" offset="1" class=" mt-3 p-0 ">
                            <div class="d-flex justify-content-between  pt-4 pb-4">
                                <template v-if="isGeo === 1">
                                    <img src="../assets/img/ardi-logo.svg" width="110" class="footer-logo">
                                </template>
                                <template v-else>
                                    <img src="../assets/img/logoEn1.svg" width="110" class="footer-logo">
                                </template>

                                <!--<div class="footer-slogan align-content-center">{{$t('footerslogan')}}</div>-->
                                <div>
                                      <img src="../assets/img/ardi_slogan.png" class="slogan-sm slogan-lg ml-4">
                                </div>
                            </div>
                        </b-col>
                    </b-container>
                </main>
            </div>
        </div>

        <div v-if="statusApprove == 1 && canceledLink == 1">
            <h1 class="text-center col-8 offset-2 mt-5">
                {{$t('confirmed')}}<br /><br />
                {{$t('insuranceadvisor')}} - {{ data.policyInfo[0].NMG_NAME_A }} {{ data.policyInfo[0].MNG_LASTNAME }}<br />
                {{$t('mob')}}: {{ data.policyInfo[0].MNG_PHONE }}<br />
                {{$t('email')}}: {{ data.policyInfo[0].MNG_EMAIL }}
            </h1>
        </div>
        <div v-if="canceledLink==0">
            <h1 class="text-center col-8 offset-2 mt-5">
                {{$t('linkdeleted')}}<br /><br />
                {{$t('insuranceadvisor')}} - {{ data.policyInfo[0].NMG_NAME_A }} {{ data.policyInfo[0].MNG_LASTNAME }}<br />
                {{$t('mob')}}: {{ data.policyInfo[0].MNG_PHONE }}<br />
                {{$t('email')}}: {{ data.policyInfo[0].MNG_EMAIL }}
            </h1>
        </div>
        <b-modal ref="counter-modal"
                 :title="$t('InfoModalHeader')"
                 id="info-modal"
                 hide-footer
                 v-b-modal.modal-sm>
            <div v-html=" $t('DeadlockMessagePart') + minutes + $t('DeadlockMessagePart2') "></div>
            <b-button :disabled="minutes!==0"
                      variant="success"
                      @click="submit(); countdownSpinner=true">
                {{ $t('confirm') }}
                <b-spinner v-if="countdownSpinner"
                           small
                           label="Small Spinner">

                </b-spinner>
            </b-button>
        </b-modal>

        <b-modal id="info-modal2"
                 ref="operation-modal"
                 :title="$t('InfoModalHeader')"
                 hide-footer
                 v-b-modal.modal-sm>
            <div v-html=" $t('OperationMessage') "></div>
            <b-button @click="reloadPage()" variant="light">{{$t('ViewPolicy')}}</b-button>
        </b-modal>
    </div>
</template>

<script>
    import Success from "@/Pcb/components/Success";
    import Signature from "@/Pcb/components/Signature";
//import MonitoringForm from "./MonitoringForm";

export default {
  name: "ContractPreview",
  components: {
      'success': Success,
      'signature': Signature
  },
  data() {
    return {
      data: null,
      checked: false,
      showSuccess: false,
      role: 1,
      isGeo: 0,
      id: this.$route.params.cont,
      cust: this.$route.params.cust,
      status: false,
      status1: false,
      status2: false,
      denial: false,
      monitoring: 1,
      rejectStatus: null,
      LoadingSpiner: false,
      minutes: 19,
      countdown: null,
      countdownSpinner: false,
      statusApprove:0,
      canceledLink:0,
    }
  },
  mounted() {
      this.$http.get(`/policy/GetStatusPro/${this.$route.params.rowid}`).then(r => {
          if (r.data == 0) {
              this.role = 0;
              this.checked = true;
          }
          else if (r.data == 2) {
              this.role = 2;
              this.checked = true;
          }
      }).catch((e) => {
          console.log(e)
      }),
          this.$http.get(`/policy/CheckCanceledProcredit/${this.$route.params.rowid}/${this.$route.params.cont}`).then(r => {
              console.log("canceledLink", r.data);
              this.canceledLink = r.data
          }).catch((e) => {
              console.log(e)
          }),
      this.$http.get(`/policy/CheckApproveProcredit/${this.$route.params.rowid}/${this.$route.params.cont}`).then(r => {
          this.statusApprove = r.data
      }).catch((e) => {
          console.log(e)
      }),
      this.$http.get(`/policy/GetPcbPolicyInfo/${this.id}/${this.cust}`).then((r) => {
      console.log(r.data)
      this.data = r.data;
      this.monitoring = r.data.policyInfo[0].ISMONITORING;
      if (r.data.isgeo === 1) {
          this.isGeo = 1;
      }
    }).catch((e) => {
      console.log(e)
    })

  },
  methods: {
      openLink: function () {
          window.open(this.data.policyInfo[0].condition, "_blank");
      },
    reloadPage() {
      this.$refs['operation-modal'].hide();
    },
    showCounterModal: function () {
      this.$refs['counter-modal'].show();

      this.minutes = 19;
      clearInterval(this.countdown);

      this.countdown = setInterval(() => {
        if (this.minutes != 0)
          this.minutes--;
      }, 1000);
    },
    Denial() {
      this.denial = true
    },
    updateMonitoring(value) {
      this.monitoring = value;
      this.LoadingSpiner = false;
    },
      submit() {
     
      console.log("submit")
      const self= this;
      //this.LoadingSpiner = true;
      //document.body.classList.toggle('loader-overlay')
        this.$http.post('/policy/CreatePolicyPcb', {
            Cust: this.$route.params.cust,
            Cont: this.$route.params.cont,
            RowId: this.$route.params.rowid,
            Policy: this.data.policyInfo[0].POLICYPRODUCT,
            ClientName: this.data.policyInfo[0].CUSTOMERNAME,
            ClientPhone: this.data.policyInfo[0].CUSTOMERPHONENUMBER,
            ControllerName: 'Pcb',
            Status: 1
      }).then((r) => {
        if (r.data.isDeadlocked) {
          this.showCounterModal();
          this.countdownSpinner=false;
        }
        if (r.data.isSuccess) {
            this.response = r.data.msg
            this.showSuccess = true;
        } else {
            this.$refs['operation-modal'].show();
        }
       
      }).catch((e) => {
        console.log(e)
        alert("შეცდომა პოლისის ჩაწერისას");
      })
      /*let that = this;
      setTimeout(function () {
        window.location = 'https://mobile.ardi.ge/api/payment/'+that.data.policyInfo[0].POLICYPRODUCT
      }, 4000)*/

    },
    reject() {
      this.status1 = true
      this.$http.post('/policy/Reject', {
        PolId: this.data.policyInfo[0].cont,
        Cust: this.data.policyInfo[0].CUSTOMER,
        Cont: this.data.policyInfo[0].cont,
        Policy: this.data.policyInfo[0].POLICYPRODUCT,
        PolicyStart: this.data.policyInfo[0].FROMDATE,
        PolicyEnd: this.data.policyInfo[0].TODATE,
        ClientName: this.data.policyInfo[0].CUSTOMERNAME,
        ClientEmail: this.data.policyInfo[0].CUST_MAIL,
        ClientPhone: this.data.policyInfo[0].CUSTOMERPHONENUMBER,
        ManagerName: this.data.policyInfo[0].NMG_NAME_A + ' ' + this.data.policyInfo[0].MNG_LASTNAME,
        ManagerPhone: this.data.policyInfo[0].MNG_PHONE,
        ManagerEmail: this.data.policyInfo[0].MNG_EMAIL,
      }).then((r) => { console.log(r.data)
      }).catch((e) => { console.error(e)
      })
      console.log("reject")

    },
    finish() {
      console.log("finish")
      this.$http.post('/policy/Reject', {
        Policy: this.data.policyInfo[0].POLICYPRODUCT,
        ClientName: this.data.policyInfo[0].CUSTOMERNAME,
        ClientEmail: this.data.policyInfo[0].CUST_MAIL,
        ClientPhone: this.data.policyInfo[0].CUSTOMERPHONENUMBER,
        ManagerPhone: this.data.policyInfo[0].MNG_PHONE,
        ManagerEmail: this.data.policyInfo[0].MNG_EMAIL,
        Cont: this.data.policyInfo[0].cont,
        RejectCode: parseInt(this.rejectStatus)
      }).then((r) => {
        console.log(r.data)
        window.location = 'https://ardi.ge/'
      }).catch((e) => {
        console.log(e)
      })

    }
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}
    .approve-cancel-btn {
        width: 50%;
        height: 130%;
        font-size: 21px;
        border-radius: 10px;
    }
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.monitoring {
  position: absolute;
  width: 100%;
  top: 0;
  background: #EEEEEE;
  z-index: 99;
}
    .border-green {
        border: 2px solid #00a987 !important;
    }
    .value-background-lrb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }
.risk-header-1 {
  font-size: 12pt;
}

.risk-header-2 {
  font-size: 10pt;
}

table {
  width: 100%;
}
    .content-header1 {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

th, td, .green-border {
  border: 1px solid #00A886;
  border-collapse: collapse;
  font-size: 10pt;
}

/*table#insured-risk, table#extra-risk {
  outline: 1px solid #00A886;
}*/

#extra-risk > tbody > tr:first-child > td {
  border-top: 0;
}

table#insured-risk td, table#extra-risk td {
  font-size: 8.3pt !important;
  border: 1px solid #EEEEEE;
}

.conditions {
  background: RGB(0, 169, 135);
  color: #EEEEEE;
}

.custom-checkbox {
  font-size: 11pt !important;
}

.description-box {
  background: #007960;
  color: #fafafa;
}

.right-border {
  border-right: 1px solid #00A886;
}

.left-border {
  border-left: 1px solid #00A886;
}

.sub-risk-text-color {
  color: #00A887;
}

.main-container {
  background-color: #fafafa !important;
}


.header-background-e {
  background-color: #eee;
}

header, h1 {
  font-size: 26px;
  color: #007960;
}

.header-background-color {
  background-color: #007960;
}

.header-background {
  background: url("../assets/img/ardi-multi-logo.svg") no-repeat center;
  background-size: cover;
}

.container {
  background-color: #fff;
}

.policy-number-background {
  background-color: #00A788;
  color: #fff;
}

.content-header {
  background-color: #005745;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

/*    .content-header-text {
        text-align: justify;
        transform: translateX(50%);
    }*/

.description {
  background-color: #007961;
  color: #fff;
  font-size: 12px;
}

.value-background {
  background-color: #fafafa !important;
  border: 1px solid #EEEEEE;
  font-size: 12px;
}

.value-border-top {
  border-top: 2px solid #00A788;
}

.footer-slogan {
  color: #14836D;
  text-transform: uppercase !important;
  -webkit-font-feature-settings: 'case' on !important;
  font-feature-settings: 'case' on !important;
}

.footer-slogan {
  font-size: 19px;
}

    .loader {
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -ms-flex-preferred-size: 25%;
        flex-basis: 25%;
        max-width: 25%;
        height: 200px;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        display: none;
    }

    .loader-overlay {
        overflow: hidden
    }

        .loader-overlay .loader {
            display: flex;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: 1000;
        }

    .loader-overlay {
        position: relative;
        width: 100%;
        height: 100%;
        /* background: #ccc; */
        z-index: 999;
    }

        .loader-overlay:after {
            position: fixed;
            content: '';
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: #efefef91;
            z-index: 9999999;
        }

    .square-spin > div {
        width: 50px;
        height: 50px;
        background: #00A987;
        -webkit-animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
        animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
    }

        .square-spin > div img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

    @-webkit-keyframes square-spin {
        25% {
            -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);
            transform: perspective(100px) rotateX(180deg) rotateY(0);
        }

        50% {
            -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);
            transform: perspective(100px) rotateX(180deg) rotateY(180deg);
        }

        75% {
            -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);
            transform: perspective(100px) rotateX(0) rotateY(180deg);
        }

        100% {
            -webkit-transform: perspective(100px) rotateX(0) rotateY(0);
            transform: perspective(100px) rotateX(0) rotateY(0);
        }
    }
    .slogan-lg {
        width: 320px;
    }
    @media (max-width: 500px) {
        .slogan-sm {
            width: 250px;
        }
    }
</style>